import { render, staticRenderFns } from "./ScoresTapestry.vue?vue&type=template&id=f25007e6"
import script from "./ScoresTapestry.vue?vue&type=script&lang=ts"
export * from "./ScoresTapestry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports